import React, { useState } from "react";
import "./matching.css";

function WesternMatch() {
  const [boySign, setBoySign] = useState("Taurus"); // Taurus
  const [girlSign, setGirlSign] = useState("Pisces"); // Pisces
  const [language, setLanguage] = useState("en");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // ✅ Loading state

  const fetchWesternMatch = () => {
    setError("");
    setResult(null);
    setLoading(true); // start loading

    fetch(
      `https://api.jyotishamastroapi.com/api/matching/western-match?boy_sign=${boySign}&girl_sign=${girlSign}&lang=${language}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          key: "2a10JhmcIyTL81Pivmzo92ynCeS04v",
        },
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error(`API error: ${res.status}`);
        return res.json();
      })
      .then((data) => setResult(data.response || data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false)); // stop loading
  };

  return (
    <div className="container">
      <div className="ra-main-matchmaking">
        <h2>Western Zodiac Compatibility</h2>

        {/* Input Section */}
        <div className="ra-main-form-section">
          <div className="form-section">
            <h3>Choose Signs</h3>
            <div className="form-grid">
              <div className="matching-form-group">
                <label>Boy Sign</label>
                <select value={boySign} onChange={(e) => setBoySign(e.target.value)}>
                  <option value="1">Aries</option>
                  <option value="2">Taurus</option>
                  <option value="3">Gemini</option>
                  <option value="4">Cancer</option>
                  <option value="5">Leo</option>
                  <option value="6">Virgo</option>
                  <option value="7">Libra</option>
                  <option value="8">Scorpio</option>
                  <option value="9">Sagittarius</option>
                  <option value="10">Capricorn</option>
                  <option value="11">Aquarius</option>
                  <option value="12">Pisces</option>
                </select>
              </div>

              <div className="matching-form-group">
                <label>Girl Sign</label>
                <select value={girlSign} onChange={(e) => setGirlSign(e.target.value)}>
                  <option value="1">Aries</option>
                  <option value="2">Taurus</option>
                  <option value="3">Gemini</option>
                  <option value="4">Cancer</option>
                  <option value="5">Leo</option>
                  <option value="6">Virgo</option>
                  <option value="7">Libra</option>
                  <option value="8">Scorpio</option>
                  <option value="9">Sagittarius</option>
                  <option value="10">Capricorn</option>
                  <option value="11">Aquarius</option>
                  <option value="12">Pisces</option>
                </select>
              </div>

              <div className="matching-form-group">
                <label>Language</label>
                <select value={language} onChange={(e) => setLanguage(e.target.value)}>
                  <option value="en">English</option>
                  <option value="hi">Hindi</option>
                  <option value="ta">Tamil</option>
                  <option value="te">Telugu</option>
                  <option value="ka">Kannada</option>
                  <option value="ml">Malayalam</option>
                  <option value="be">Bengali</option>
                  <option value="gr">Greek</option>
                  <option value="mr">Marathi</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <button
          className="match-btn"
          onClick={fetchWesternMatch}
          disabled={loading} // disable button while loading
        >
          {loading ? "Checking..." : "Check Compatibility"}
        </button>

        {/* Loading Message */}
        {loading && !error && <div className="loading-msg">Loading...</div>}

        {/* Error Message */}
        {error && <div className="error-msg">Error: {error}</div>}

        {/* Result */}
        {result && (
          <div className="result-section">
            <h3>Result</h3>
            <div className="score-box">
              <p>
                <strong>Boy Sign:</strong> {result.boy_sign}
              </p>
              <p>
                <strong>Girl Sign:</strong> {result.girl_sign}
              </p>
              <p>
                <strong>Score:</strong> {result.score} / {result.total}
              </p>
              {result.bot_response && (
                <p className="bot-response">💡 {result.bot_response}</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default WesternMatch;
